import { motion } from "motion/react";
import SearchResultCard from "@/theme1/components/search/SearchResultCard";

export default function SearchResults({
  groupedResults,
  query,
  activeIndex,
  onSelect,
}) {
  let globalIndex = -1;

  return (
    <div className="space-y-6">
      {Object.entries(groupedResults).map(([group, items]) => (
        <motion.div
          key={group}
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <h3 className="mb-3 text-xs font-semibold uppercase tracking-[0.25em] text-muted-foreground">
            {group}
          </h3>

          <div className="space-y-1">
            {items.map((item) => {
              globalIndex += 1;

              return (
                <SearchResultCard
                  key={`${item.type}-${item.id}`}
                  item={item}
                  query={query}
                  active={activeIndex === globalIndex}
                  onSelect={onSelect}
                />
              );
            })}
          </div>
        </motion.div>
      ))}
    </div>
  );
}